import React, { createContext, useContext, useState, useCallback } from 'react';

const SurveyContext = createContext();

export const useSurvey = () => useContext(SurveyContext);

export const SurveyProvider = ({ children }) => {
    const [isOverlayOpen, setIsOverlayOpen] = useState(false);
    const [activeInstanceId, setActiveInstanceId] = useState(null);
    const [isFullScreen, setIsFullScreen] = useState(true); // Default to full-screen mode

    const startSurvey = useCallback((instanceId, fullScreen = true) => {
        setActiveInstanceId(instanceId);
        setIsFullScreen(fullScreen);
        setIsOverlayOpen(true);
    }, []);

    const closeSurvey = useCallback(() => {
        setIsOverlayOpen(false);
        setActiveInstanceId(null);
        // Dispatch custom event for components to listen to
        window.dispatchEvent(new CustomEvent('surveyCompleted'));
    }, []);

    return (
        <SurveyContext.Provider value={{ 
            isOverlayOpen, 
            activeInstanceId, 
            isFullScreen,
            startSurvey, 
            closeSurvey
        }}>
            {children}
        </SurveyContext.Provider>
    );
};
